import { PlaylistAddCheck } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { DatePicker } from '@mui/x-date-pickers';
import ModalPreVisualizacaoCertidao from '@/components/ModalPreVisualizacaoCertidao';
import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { Fragment } from 'react';
import Signatario from '../certidao/Signatario';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';

class ConfirmarPublicarPautaLote extends ReactComponent {
    dialogListagemOpen = false;
    dialogConfirmacaoOpen = false;
    carregando = false;
    carregandoPreVisualizacao = false;
    carregandoPreVisualizacaoCertidao = false;
    dataLimitePublicacao;
    dataLimiteDisponibilizacao;
    dataLimiteEnvio;
    dataDisponibilizacao;
    dataProximaDisponibilizacao;
    dataPublicacao;
    cpfSignatario;
    errosValidacaoFechamento = [];
    codigoOTP;
    previaPublicacaoHTML = '';
    previaCertidaoHTML = '';
    openDialog = false;
    openModalCertidao = false;
    cabecalhoPublicacao;
    confirmarPublicarDiario = true;
    enviarCertidao = true;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogListagemOpen: observable,
            dialogConfirmacaoOpen: observable,
            carregando: observable,
            carregandoPreVisualizacao: observable,
            carregandoPreVisualizacaoCertidao: observable,
            dataLimitePublicacao: observable,
            dataLimiteDisponibilizacao: observable,
            dataLimiteEnvio: observable,
            dataDisponibilizacao: observable,
            dataProximaDisponibilizacao: observable,
            dataPublicacao: observable,
            cpfSignatario: observable,
            errosValidacaoFechamento: observable,
            codigoOTP: observable,
            previaPublicacaoHTML: observable,
            previaCertidaoHTML: observable,
            openDialog: observable,
            openModalCertidao: observable,
            cabecalhoPublicacao: observable,
            confirmarPublicarDiario: observable,
            enviarCertidao: observable,
            handleClickIcone: action,
            handleCloseDialog: action,
            handleCloseDialogConfirmacao: action,
            handleConfirmarPublicar: action,
            datasPreVisualizacaoCertidao: computed,
            publicarPautaDto: computed,
            configurarValorInicialPublicar: action,
            processosConfirmarPublicar: computed,
            processosPublicacao: computed,
            processosConfirmados: computed,
            processosJaConfirmados: computed,
            processosConfirmacaoPublicacao: computed,
            handleChangeCodigoOTP: action,
            isPeriodoPautaEncerrado: computed,
            callbackAlterarCpfSignatario: action,
            quantidadeProcessosSelecionados: computed,
            desabilitarPublicar: computed,
            handleChangeDataDisponibilizacao: action,
            handleChangeDataPublicacao: action,
            limparProcessoPesquisa: action,
            processos: computed,
            processosSelecionados: computed,
            existeProcessoParaPublicacao: computed,
            quantidadeProcessosPublicacao: computed,
            pautaExclusivamenteVirtual: computed,
            pautaExclusivamentePresencial: computed,
            mensagemLoteSemProcessos: computed,
            handleClickConfirmar: action,
            abrirModalVisualizacaoCertidao: action,
            handleCloseModalCertidao: action,
            handleCabecalhoPublicacao: action,
            renderConteudo: computed,
            desabilitarConfirmar: computed,
            mensagemConfirmacaoPublicacaoDiario: computed,
            handleChangeConfirmarPublicarDiario: action,
            handleChangeEnviarCertidao: action,
            mensagemValidacaoDataDisponibilizacao: computed
        });
    }

    handleClickIcone = async () => {
        this.dialogListagemOpen = true;
        this.carregarSignatario();
        this.configurarValorInicialPublicar();
    };

    handleCloseDialog = () => {
        this.dialogListagemOpen = false;
    };

    handleCloseDialogConfirmacao = () => {
        this.dialogConfirmacaoOpen = false;
    };

    handleConfirmarPublicar = async () => {
        await this.pautaJulgamentoStore.processarLote({
            titulo: 'Confirmando inclusão de processos',
            indeterminate: true,
            qtdTotalProcessos: this.processosConfirmarPublicar.length,
            lotesProcessos: [this.processosConfirmarPublicar],
            funcaoOperacao: this.confirmarPublicarPauta
        });
        this.handleCloseDialogConfirmacao();
        await this.sessaoStore.recarregarListaProcessos();
    };

    confirmarPublicarPauta = async () => {
        let resultado = await this.sessaoService.confirmarPublicarPauta(
            this.pautaJulgamentoStore.idPautaSelecionada,
            this.publicarPautaDto,
            this.enviarCertidao,
            this.confirmarPublicarDiario,
            true
        );
        this.pautaJulgamentoStore.atualizarProcessamentoLote(resultado);
        return resultado;
    };

    get datasPreVisualizacaoCertidao() {
        let datasPreVisualizacaoCertidao = {
            dataDisponibilizacao: this.dataDisponibilizacao?.format('YYYY-MM-DD'),
            dataPublicacao: this.dataPublicacao?.format('YYYY-MM-DD')
        };

        return datasPreVisualizacaoCertidao;
    }

    get publicarPautaDto() {
        let publicarPautaDto = {
            dataDisponibilizacao: this.dataDisponibilizacao?.format('YYYY-MM-DD'),
            dataPublicacao: this.dataPublicacao?.format('YYYY-MM-DD'),
            otp: this.codigoOTP,
            cpfSignatario: this.cpfSignatario,
            processosConfirmacao: this.processosConfirmarPublicar,
            cabecalhoPublicacao: this.cabecalhoPublicacao,
            tipoPublicacao: 'PAUTA'
        };

        return publicarPautaDto;
    }

    get mensagemSucesso() {
        return this.processosSelecionados.length > 1
            ? 'Processos confirmados' + (this.existeProcessoParaPublicacao ? '/publicados' : '') + ' com sucesso'
            : 'Processo confirmado' + (this.existeProcessoParaPublicacao ? '/publicado' : '') + ' com sucesso';
    }

    configurarValorInicialPublicar() {
        this.processos.forEach((registro) => {
            //não deixa marcar os já publicados
            registro.checkedPublicacaoPauta =
                !registro.confirmadaPublicacaoPauta && registro.tipoInclusao === 'APTO_PAUTA';
        });
    }

    get processosConfirmarPublicar() {
        return this.processosSelecionados.map((registro) => ({
            numero: registro.processo.numeroCompleto,
            publicar: !registro.confirmadaPublicacaoPauta && registro.checkedPublicacaoPauta,
            confirmar: !registro.confirmadaInclusaoPauta && this.store.isCheckedOperacoesEmLote(registro)
        }));
    }

    get processosPublicacao() {
        return this.processosSelecionados.filter(
            (registro) => registro.checkedPublicacaoPauta && !registro.confirmadaPublicacaoPauta
        );
    }

    get processosConfirmados() {
        return this.processosSelecionados.filter(
            (registro) => !registro.checkedPublicacaoPauta && this.store.isCheckedOperacoesEmLote(registro)
        );
    }

    get processosJaConfirmados() {
        return this.processosSelecionados.filter(
            (registro) => registro.confirmadaInclusaoPauta && registro.checkedPublicacaoPauta
        );
    }

    get processosConfirmacaoPublicacao() {
        return this.processosSelecionados.filter(
            (registro) =>
                this.store.isCheckedOperacoesEmLote(registro) &&
                registro.checkedPublicacaoPauta &&
                !registro.confirmadaInclusaoPauta
        );
    }

    handleChangeCodigoOTP = (event) => {
        this.codigoOTP = event.target.value;
        this.codigoOTP = this.codigoOTP.toString();
    };

    carregar = async () => {
        runInAction(() => (this.carregando = true));

        if (this.sessao) {
            let prazos = await this.sessaoService.recuperarPrazosPublicacaoPauta(
                this.pautaJulgamentoStore.getDataInicioJulgamento()
            );
            runInAction(() => {
                this.dataLimitePublicacao = moment(prazos.dataLimitePublicacao, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataLimiteDisponibilizacao = moment(
                    prazos.dataLimiteDisponibilizacao,
                    'DD-MM-YYYY-HH-mm-ss',
                    true
                );
                this.dataLimiteEnvio = moment(prazos.dataLimiteEnvio, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataDisponibilizacao = moment(prazos.dataProximaDisponibilizacao, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataProximaDisponibilizacao = moment(
                    prazos.dataProximaDisponibilizacao,
                    'DD-MM-YYYY-HH-mm-ss',
                    true
                );
                this.dataPublicacao = moment(prazos.dataProximaPublicacao, 'DD-MM-YYYY-HH-mm-ss', true);
            });
            let cabecalhoPublicacao = await this.sessaoService.buscarCabecalhoPulicacaoPauta(
                this.pautaJulgamentoStore.idPautaSelecionada
            );
            runInAction(() => (this.cabecalhoPublicacao = cabecalhoPublicacao));
        }
        runInAction(() => (this.carregando = false));
    };

    get isPeriodoPautaEncerrado() {
        return this.existeProcessoParaPublicacao && moment().isAfter(this.dataLimiteEnvio);
    }

    carregarSignatario() {
        if (this.sessao.orgaoJudicante) {
            this.cpfSignatario = this.dominioStore.temSignatariosCadastradosOjc(this.sessao.orgaoJudicante.sigla)
                ? this.dominioStore.signatarioCadastradoDefaultOjc(this.sessao.orgaoJudicante.sigla).cpf
                : this.usuarioStore.usuario.cpf;
        } else {
            this.cpfSignatario = this.usuarioStore.usuario.cpf;
        }
    }

    async callbackAlterarCpfSignatario(cpfSignatario) {
        this.cpfSignatario = cpfSignatario;
    }

    get sessao() {
        return this.pautaJulgamentoStore.sessaoSelecionada;
    }

    get quantidadeProcessosSelecionados() {
        return this.processosSelecionados.length;
    }

    quantidadeProcessosPorTipoInclusao(tipoInclusao) {
        return this.processosSelecionados.filter((processo) => processo.tipoInclusao === tipoInclusao).length;
    }

    get desabilitarPublicar() {
        return !this.existeProcessoParaPublicacao;
    }

    formatarValorData(value) {
        let novoValor = value;
        if (value) {
            novoValor = moment(value.format('DD-MM-YYYY') + '-' + moment().format('HH-mm-ss'), 'DD-MM-YYYY-HH-mm-ss');
        }
        return novoValor;
    }

    handleChangeDataDisponibilizacao = async (value) => {
        this.dataDisponibilizacao = this.formatarValorData(value);
        if (this.dataDisponibilizacao) {
            let prazos = await this.sessaoService.recuperarPrazosPublicacaoPauta(
                this.pautaJulgamentoStore.getDataInicioJulgamento(),
                this.dataDisponibilizacao.format('DD-MM-YYYY-HH-mm-ss')
            );
            runInAction(() => {
                this.dataPublicacao = moment(prazos.dataProximaPublicacao, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataDisponibilizacao = moment(prazos.dataProximaDisponibilizacao, 'DD-MM-YYYY-HH-mm-ss', true);
            });
        }
    };

    handleChangeDataPublicacao = async (value) => {
        this.dataPublicacao = this.formatarValorData(value);
    };

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get processos() {
        return (this.pautaJulgamentoStore.processosPautaSelecionadaFiltrados || []).filter(
            (registro) =>
                (!registro.confirmadaPublicacaoPauta || !registro.confirmadaInclusaoPauta) &&
                this.filtrarProcessoPeloNumero(registro)
        );
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get existeProcessoParaPublicacao() {
        return this.quantidadeProcessosPublicacao > 0;
    }

    get quantidadeProcessosPublicacao() {
        return this.processosPublicacao.length;
    }

    get pautaExclusivamenteVirtual() {
        return (
            this.sessaoStore.sessaoSelecionada &&
            SituacaoJulgamentoProcessoBusiness.isProcessoPautadoEmJulgamentoExclusivamenteVirtual(
                this.sessaoStore.sessaoSelecionada.tipoJulgamento
            )
        );
    }

    get pautaExclusivamentePresencial() {
        return SituacaoJulgamentoProcessoBusiness.isJulgamentoExclusivamentePresencial(
            this.sessaoStore?.sessaoSelecionada
        );
    }

    temInconsistenciaTipoJulgamento(registro) {
        return (
            (this.pautaExclusivamenteVirtual &&
                registro.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo) ||
            (this.pautaExclusivamentePresencial &&
                registro.tipoJulgamento !== MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo)
        );
    }

    get processosSelecionaveis() {
        return this.processos.filter((registro) => !this.temInconsistenciaTipoJulgamento(registro));
    }

    get mensagemLoteSemProcessos() {
        return 'Não há processos para confirmar/publicar em pauta' + this.complementoMensagemFiltrando;
    }

    handleClickConfirmar = async () => {
        this.dialogConfirmacaoOpen = true;
        await this.carregar();
    };

    abrirModalVisualizacaoCertidao = () => {
        this.openModalCertidao = true;
    };

    handleCloseModalCertidao = () => {
        this.openModalCertidao = false;
    };

    handleCabecalhoPublicacao = (event) => {
        this.cabecalhoPublicacao = event.target.value;
    };

    render() {
        return (
            <Fragment>
                <div
                    style={{ marginRight: '10px', paddingLeft: '5px' }}
                    className="corBotao"
                >
                    <Tooltip
                        title={'Confirmar/publicar processos em pauta'}
                        placement="top-start"
                    >
                        <PlaylistAddCheck
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                            onClick={this.handleClickIcone}
                        />
                    </Tooltip>
                </div>
                {this.dialogListagemOpen && (
                    <Dialog
                        open
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        PaperProps={{ style: { height: '100%' } }}
                    >
                        <DialogTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        flexGrow: 1
                                    }}
                                >
                                    <h4 style={{ margin: '0px' }}>Confirmar/publicar processos em pauta</h4>
                                    <div style={{ margin: '0px 10px' }}>
                                        <NumeroProcesso
                                            dense
                                            tooltip="Número do processo a ser pesquisado na listagem"
                                            callbackOnChange={this.callbackNumeroProcesso}
                                            clickLimpar={this.limparProcessoPesquisa}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                margin: '10px',
                                                paddingTop: '5px'
                                            }}
                                        >
                                            <PainelFiltros />
                                        </div>
                                        <FiltroRapido id="filtroRapidoConfirmarPublicarProcessosLote" />
                                    </div>
                                </div>
                            </div>
                        </DialogTitle>
                        {this.renderConteudo}
                    </Dialog>
                )}
                {this.renderDialogConfirmacao()}
            </Fragment>
        );
    }

    get renderConteudo() {
        return this.sessaoStore.carregandoProcessos ? (
            <div style={{ display: 'flex' }}>
                <CircularProgress
                    disableShrink
                    style={{ margin: '20px' }}
                />
                <Typography
                    variant="h6"
                    style={{ margin: '25px 10px' }}
                >
                    Carregando processos...
                </Typography>
            </div>
        ) : (
            <Fragment>
                <OperacoesEmLoteSelecionar
                    publicarPauta
                    processosSelecionaveis={this.processosSelecionaveis}
                    processos={this.processos}
                />
                <PainelProcessosOperacoesEmLote
                    publicarPauta
                    processos={this.processos}
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                />
                <DialogActions>
                    <Button
                        onClick={this.handleCloseDialog}
                        color="secondary"
                        variant="outlined"
                        endIcon={<CancelIcon />}
                    >
                        Fechar
                    </Button>
                    <Button
                        onClick={this.handleClickConfirmar}
                        color="primary"
                        variant="outlined"
                        endIcon={<CheckIcon />}
                        disabled={!this.processosSelecionados || this.processosSelecionados.length === 0}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Fragment>
        );
    }

    renderDialogConfirmacao() {
        return (
            this.dialogConfirmacaoOpen && (
                <Dialog
                    open
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>Confirmar/publicar processos em pauta</DialogTitle>
                    <DialogContent>
                        {this.carregando ? (
                            <CircularProgress
                                style={{ margin: '10px' }}
                                disableShrink={true}
                            />
                        ) : (
                            this.renderConteudoConfirmacao()
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleCloseDialogConfirmacao}
                            color="secondary"
                            variant="outlined"
                            endIcon={<CancelIcon />}
                        >
                            Fechar
                        </Button>
                        <Tooltip
                            placement="top-start"
                            title={this.getTooltipBotaoConfirmar()}
                        >
                            <div>
                                <Button
                                    onClick={this.handleConfirmarPublicar}
                                    color="primary"
                                    variant="outlined"
                                    endIcon={<CheckIcon />}
                                    disabled={this.desabilitarConfirmar}
                                >
                                    Confirmar
                                </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
            )
        );
    }

    getTooltipBotaoConfirmar() {
        if (this.existeProcessoParaPublicacao && this.mensagemValidacaoDataDisponibilizacao) {
            return this.mensagemValidacaoDataDisponibilizacao;
        }
        return this.existeProcessoParaPublicacao && !this.isPeriodoPautaEncerrado ? 'Preencha todos os campos' : '';
    }

    get desabilitarConfirmar() {
        return (
            !this.dataDisponibilizacao ||
            (this.existeProcessoParaPublicacao && this.enviarCertidao && !this.isStringPreenchida(this.codigoOTP))
        );
    }

    get mensagemConfirmacaoPublicacaoDiario() {
        return this.confirmarPublicarDiario
            ? 'A Secretaria Eletrônica enviará o tipo de comunicação Intimação ao DJEN e registrará os movimentos de disponibilização e publicação no sistema de origem.'
            : 'A Secretaria Eletrônica registrará os movimentos de disponibilização e publicação no sistema de origem SEM o envio do tipo de comunicação Intimação ao DJEN.';
    }

    isStringPreenchida(string) {
        return string && (string + '').trim() !== '';
    }

    renderConteudoConfirmacao() {
        return (
            <Fragment>
                {this.renderErros()}
                {this.renderQuantidadeProcessos()}
                {this.existeProcessoParaPublicacao && (
                    <Fragment>
                        {this.renderDatasLimites()}
                        {this.renderDataDisponibilizacaoDataPublicacao()}
                        {this.renderConfirmarPublicarDiario()}
                        {this.renderCamposPublicacao()}
                    </Fragment>
                )}
            </Fragment>
        );
    }

    renderConfirmarPublicarDiario() {
        return (
            <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', marginLeft: '26px' }}>
                <Typography
                    variant="subtitle1"
                    color="primary"
                    style={{ marginRight: '39px', whiteSpace: 'nowrap', textAlign: 'right', width: '110px' }}
                >
                    <b>Enviar para o DJEN</b>
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <div style={{ width: '100%' }}>
                        <Checkbox
                            checked={this.confirmarPublicarDiario}
                            onChange={this.handleChangeConfirmarPublicarDiario}
                            style={{ padding: '4px' }}
                        />
                        <IconButton
                            color="inherit"
                            aria-label={this.mensagemConfirmacaoPublicacaoDiario}
                            style={{ width: '50px' }}
                            size="large"
                        >
                            <Tooltip title={this.mensagemConfirmacaoPublicacaoDiario}>
                                <InfoIcon style={{ color: '#01579b' }} />
                            </Tooltip>
                        </IconButton>
                    </div>
                </div>
            </div>
        );
    }

    handleChangeConfirmarPublicarDiario = () => {
        this.confirmarPublicarDiario = !this.confirmarPublicarDiario;
    };

    handleChangeEnviarCertidao = () => {
        this.enviarCertidao = !this.enviarCertidao;
    };

    getMinDate() {
        if (!this.confirmarPublicarDiario || !this.existeProcessoParaPublicacao) {
            return this.dataProximaDisponibilizacao.subtract(30, 'days');
        } else {
            return this.dataProximaDisponibilizacao;
        }
    }

    renderDataDisponibilizacaoDataPublicacao() {
        return (
            <Fragment>
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '10px' }}>
                    <Typography
                        variant="subtitle1"
                        color="primary"
                        style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                        <b>Data disponibilização</b>
                    </Typography>
                    <DatePicker
                        value={this.dataDisponibilizacao}
                        onChange={this.handleChangeDataDisponibilizacao}
                        slotProps={{
                            textField: {
                                helperText: this.mensagemValidacaoDataDisponibilizacao
                            }
                        }}
                        disablePast={this.confirmarPublicarDiario && this.existeProcessoParaPublicacao}
                        minDate={this.getMinDate()}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '50px' }}>
                    <Typography
                        variant="subtitle1"
                        color="primary"
                        style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                        <b>Data publicação</b>
                    </Typography>
                    <DatePicker
                        value={this.dataPublicacao}
                        onChange={this.handleChangeDataPublicacao}
                        disablePast={this.confirmarPublicarDiario}
                        minDate={
                            this.dataDisponibilizacao ? this.dataDisponibilizacao.clone().add(1, 'days') : undefined
                        }
                    />
                </div>
            </Fragment>
        );
    }

    get mensagemValidacaoDataDisponibilizacao() {
        if (!this.dataDisponibilizacao) {
            return 'Data não inválida ou não informada';
        }

        if (!this.dataDisponibilizacao.isValid()) {
            return 'A data informada é inválida';
        }

        if (this.dataDisponibilizacao.isBefore(this.dataProximaDisponibilizacao)) {
            return 'A data informada é anterior à data limite.';
        }

        if (this.dataDisponibilizacao.isAfter(this.dataLimiteDisponibilizacao)) {
            return 'A data informada é posterior à data limite.';
        }

        return null;
    }

    renderDatasLimites() {
        return (
            <Fragment>
                <div style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                    <Typography display="inline">
                        <b>Data limite para envio: </b>
                        {this.dataLimiteEnvio && this.dataLimiteEnvio.format('DD/MM/YYYY HH:mm')}
                    </Typography>
                </div>
                <div style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                    <Typography display="inline">
                        <b>Data limite para disponibilização: </b>
                        {this.dataLimiteDisponibilizacao && this.dataLimiteDisponibilizacao.format('DD/MM/YYYY')}
                    </Typography>
                </div>
                <div style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                    <Typography display="inline">
                        <b>Data limite para publicação: </b>
                        {this.dataLimitePublicacao && this.dataLimitePublicacao.format('DD/MM/YYYY')}
                    </Typography>
                </div>
            </Fragment>
        );
    }

    renderQuantidadeProcessos() {
        return (
            <Fragment>
                <div style={{ marginBottom: '8px', paddingLeft: '10px', lineHeight: 1.5 }}>
                    <Accordion defaultExpanded={this.existeProcessoParaPublicacao ? false : true}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography style={{ fontWeight: 'bold' }}>
                                Total de processos selecionados: {this.quantidadeProcessosSelecionados}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                <li>Aptos à pauta: {this.quantidadeProcessosPorTipoInclusao('APTO_PAUTA')}</li>
                                <li>Remanescentes: {this.quantidadeProcessosPorTipoInclusao('REMANESCENTE')}</li>
                                {this.pautaJulgamentoStore.origemPautaSelecionadaPJe && (
                                    <li>
                                        Aptos à sessão: {this.quantidadeProcessosPorTipoInclusao('APTO_JULGAMENTO')}
                                    </li>
                                )}
                                {this.pautaJulgamentoStore.origemPautaSelecionadaSIJ && (
                                    <li>
                                        Agravos providos: {this.quantidadeProcessosPorTipoInclusao('AGRAVO_PROVIDO')}
                                    </li>
                                )}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography style={{ fontWeight: 'bold' }}>
                                            {this.processosConfirmados.length} processo(s) serão confirmados
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            {this.processosConfirmados.filter(
                                                (processo) => processo.tipoInclusao === 'APTO_PAUTA'
                                            ).length > 0 ? (
                                                <li>
                                                    Aptos à pauta:{' '}
                                                    {
                                                        this.processosConfirmados.filter(
                                                            (processo) => processo.tipoInclusao === 'APTO_PAUTA'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                            {this.processosConfirmados.filter(
                                                (processo) => processo.tipoInclusao === 'REMANESCENTE'
                                            ).length > 0 ? (
                                                <li>
                                                    Remanescentes:{' '}
                                                    {
                                                        this.processosConfirmados.filter(
                                                            (processo) => processo.tipoInclusao === 'REMANESCENTE'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                            {this.pautaJulgamentoStore.origemPautaSelecionadaPJe &&
                                            this.processosConfirmados.filter(
                                                (processo) => processo.tipoInclusao === 'APTO_JULGAMENTO'
                                            ).length > 0 ? (
                                                <li>
                                                    Aptos à sessão:{' '}
                                                    {
                                                        this.processosConfirmados.filter(
                                                            (processo) => processo.tipoInclusao === 'APTO_JULGAMENTO'
                                                        ).length
                                                    }{' '}
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                            {this.pautaJulgamentoStore.origemPautaSelecionadaSIJ &&
                                            this.processosConfirmados.filter(
                                                (processo) => processo.tipoInclusao === 'AGRAVO_PROVIDO'
                                            ).length > 0 ? (
                                                <li>
                                                    Agravos providos:{' '}
                                                    {
                                                        this.processosConfirmados.filter(
                                                            (processo) => processo.tipoInclusao === 'AGRAVO_PROVIDO'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography style={{ fontWeight: 'bold' }}>
                                            {this.processosJaConfirmados.length} processos(s) serão disponibilizados
                                            para publicação
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            {this.processosJaConfirmados.filter(
                                                (processo) => processo.tipoInclusao === 'APTO_PAUTA'
                                            ).length > 0 ? (
                                                <li>
                                                    Aptos à pauta:{' '}
                                                    {
                                                        this.processosJaConfirmados.filter(
                                                            (processo) => processo.tipoInclusao === 'APTO_PAUTA'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                            {this.processosJaConfirmados.filter(
                                                (processo) => processo.tipoInclusao === 'REMANESCENTE'
                                            ).length > 0 ? (
                                                <li>
                                                    Remanescentes:{' '}
                                                    {
                                                        this.processosJaConfirmados.filter(
                                                            (processo) => processo.tipoInclusao === 'REMANESCENTE'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                            {this.pautaJulgamentoStore.origemPautaSelecionadaPJe &&
                                            this.processosJaConfirmados.filter(
                                                (processo) => processo.tipoInclusao === 'APTO_JULGAMENTO'
                                            ).length > 0 ? (
                                                <li>
                                                    Aptos à sessão:{' '}
                                                    {
                                                        this.processosJaConfirmados.filter(
                                                            (processo) => processo.tipoInclusao === 'APTO_JULGAMENTO'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                            {this.pautaJulgamentoStore.origemPautaSelecionadaSIJ &&
                                            this.processosJaConfirmados.filter(
                                                (processo) => processo.tipoInclusao === 'AGRAVO_PROVIDO'
                                            ).length > 0 ? (
                                                <li>
                                                    Agravos providos:{' '}
                                                    {
                                                        this.processosJaConfirmados.filter(
                                                            (processo) => processo.tipoInclusao === 'AGRAVO_PROVIDO'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography style={{ fontWeight: 'bold' }}>
                                            {this.processosConfirmacaoPublicacao.length} processo(s) serão confirmados e
                                            disponibilizados para publicação
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            {this.processosConfirmacaoPublicacao.filter(
                                                (processo) => processo.tipoInclusao === 'APTO_PAUTA'
                                            ).length > 0 ? (
                                                <li>
                                                    Aptos à pauta:{' '}
                                                    {
                                                        this.processosConfirmacaoPublicacao.filter(
                                                            (processo) => processo.tipoInclusao === 'APTO_PAUTA'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                            {this.processosConfirmacaoPublicacao.filter(
                                                (processo) => processo.tipoInclusao === 'REMANESCENTE'
                                            ).length > 0 ? (
                                                <li>
                                                    Remanescentes:{' '}
                                                    {
                                                        this.processosConfirmacaoPublicacao.filter(
                                                            (processo) => processo.tipoInclusao === 'REMANESCENTE'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                            {this.pautaJulgamentoStore.origemPautaSelecionadaPJe &&
                                            this.processosConfirmacaoPublicacao.filter(
                                                (processo) => processo.tipoInclusao === 'APTO_JULGAMENTO'
                                            ).length > 0 ? (
                                                <li>
                                                    Aptos à sessão:{' '}
                                                    {
                                                        this.processosConfirmacaoPublicacao.filter(
                                                            (processo) => processo.tipoInclusao === 'APTO_JULGAMENTO'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                            {this.pautaJulgamentoStore.origemPautaSelecionadaSIJ &&
                                            this.processosConfirmacaoPublicacao.filter(
                                                (processo) => processo.tipoInclusao === 'AGRAVO_PROVIDO'
                                            ).length > 0 ? (
                                                <li>
                                                    Agravos providos:{' '}
                                                    {
                                                        this.processosConfirmacaoPublicacao.filter(
                                                            (processo) => processo.tipoInclusao === 'AGRAVO_PROVIDO'
                                                        ).length
                                                    }
                                                </li>
                                            ) : (
                                                <div></div>
                                            )}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <div style={{ margin: '10px 10px' }}></div>
                </div>
            </Fragment>
        );
    }
    renderCabecalhoPublicacao() {
        return (
            <div style={{ marginBottom: '15px', marginTop: '15px', marginLeft: '30px' }}>
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '10px' }}>
                    <Typography
                        variant="subtitle1"
                        color="primary"
                        style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                        <b>Texto Publicação</b>
                    </Typography>
                    <TextField
                        id={'cabecalhoPublicacao'}
                        value={this.cabecalhoPublicacao}
                        multiline={true}
                        onChange={this.handleCabecalhoPublicacao}
                        variant="outlined"
                        fullWidth={true}
                        size={'small'}
                        maxRows={15}
                    />
                </div>
            </div>
        );
    }

    renderCamposPublicacao() {
        return (
            <Fragment>
                <div style={{ marginLeft: '81px' }}>
                    <Signatario
                        cpfSignatario={this.cpfSignatario}
                        callbackAlterarCpfSignatario={this.callbackAlterarCpfSignatario.bind(this)}
                    />
                </div>
                {!this.desabilitarPublicar && (
                    <Fragment>
                        {this.confirmarPublicarDiario && (
                            <Fragment>
                                {this.renderCabecalhoPublicacao()}
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        margin: '3px 0px',
                                        marginLeft: '70px'
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        color="primary"
                                        style={{
                                            marginRight: '15px',
                                            whiteSpace: 'nowrap',
                                            textAlign: 'right',
                                            width: '110px'
                                        }}
                                    >
                                        <b>{'Publicador'}</b>
                                    </Typography>
                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                        <div style={{ width: '100%' }}>
                                            <TextField
                                                disabled
                                                id={'teste'}
                                                value={this.usuarioStore.usuario.nome}
                                                variant="outlined"
                                                fullWidth={true}
                                                size={'small'}
                                                margin={'dense'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        )}
                        <Fragment>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    margin: '3px 0px',
                                    marginLeft: '60px'
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    color="primary"
                                    style={{
                                        marginRight: '15px',
                                        whiteSpace: 'nowrap',
                                        textAlign: 'left',
                                        width: '100px'
                                    }}
                                >
                                    <b>Gerar certidão</b>
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                        <Checkbox
                                            checked={this.enviarCertidao}
                                            onChange={this.handleChangeEnviarCertidao}
                                            style={{ padding: '4px' }}
                                        />
                                        <ModalPreVisualizacaoCertidao
                                            processosConfirmacaoPublicacao={this.processosConfirmacaoPublicacao}
                                            existeProcessoParaPublicacao={this.existeProcessoParaPublicacao}
                                            datasPreVisualizacaoCertidao={this.datasPreVisualizacaoCertidao}
                                            idPautaSelecionada={this.pautaJulgamentoStore.idPautaSelecionada}
                                            enviarCertidao={this.enviarCertidao}
                                            openModalCertidao={this.openModalCertidao}
                                            callbackCancelar={this.handleCloseModalCertidao}
                                            callbackAbrirModal={this.abrirModalVisualizacaoCertidao}
                                        />
                                        <IconButton
                                            color="inherit"
                                            aria-label="Gerar certidão"
                                            style={{ width: '50px' }}
                                            size="large"
                                        >
                                            <Tooltip
                                                title={
                                                    this.enviarCertidao
                                                        ? 'Incluir certidão de inclusão em pauta para os processos selecionados.'
                                                        : ' NÃO haverá a anexação de certidão de inclusão em pauta nos processos selecionados'
                                                }
                                            >
                                                <InfoIcon style={{ color: '#01579b' }} />
                                            </Tooltip>
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                            {this.enviarCertidao && (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        margin: '3px 0px',
                                        marginLeft: '70px'
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        color="primary"
                                        style={{
                                            marginRight: '15px',
                                            whiteSpace: 'nowrap',
                                            textAlign: 'right',
                                            width: '95px'
                                        }}
                                    >
                                        <b>{'Código OTP'}</b>
                                    </Typography>
                                    <div style={{ display: 'flex', alignItems: 'center', width: '40%' }}>
                                        <div style={{ width: '100%' }}>
                                            <TextField
                                                id={'idCodigoOTP'}
                                                variant="outlined"
                                                type="number"
                                                fullWidth={true}
                                                size={'small'}
                                                margin={'dense'}
                                                onChange={this.handleChangeCodigoOTP}
                                                disabled={this.desabilitarPublicar}
                                            />
                                        </div>
                                        <div>
                                            <IconButton
                                                color="inherit"
                                                aria-label="Codigo OTP"
                                                style={{ width: '50px' }}
                                                size="large"
                                            >
                                                <Tooltip
                                                    title={
                                                        'Código OTP gerado pelo aplicativo JTe. Será utilizado para assinatura das certidões de inclusão em pauta geradas nos processos que forem publicados.'
                                                    }
                                                >
                                                    <InfoIcon style={{ color: '#01579b' }} />
                                                </Tooltip>
                                            </IconButton>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Fragment>
                    </Fragment>
                )}
            </Fragment>
        );
    }

    renderErros() {
        return (
            <Fragment>
                {this.isPeriodoPautaEncerrado && (
                    <div style={{ color: 'orange', marginBottom: '15px', paddingLeft: '10px' }}>
                        <div style={{ marginBottom: '4px' }}>
                            <Typography display="inline">
                                <b>Atenção: Período para envio da pauta encerrado.</b>
                            </Typography>
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default inject('stores')(observer(ConfirmarPublicarPautaLote));
